import { GameSummaryProperties } from "@lib/js-slingo-pawnshop-core/dist";
export class GameSummaryLandscapeProperties extends GameSummaryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.panelSpineProperties.position.set(1390, 692);
    }
}
